export enum Sandbox {
    None = "None",
    Storybook = "Storybook",
}

/**
 * Determine if we're running inside a sandbox like React Sandbox or Storybook.
 *
 * DO NOT use this in your React components. Use sandbox-context.js instead.
 *
 * This abstracts away how we determine this so that we can easily change this
 * mechanism in future without updating all the code that references it.
 *
 * @export
 * @returns {Sandbox} `Sandbox.None` if we're not in a sandbox; otherwise, a
 * value representing the type of sandbox.
 */
export const inSandbox = (): Sandbox => {
    // See https://storybook.js.org/docs/react/faq#how-can-my-code-detect-if-it-is-running-in-storybook
    if (process.env.STORYBOOK) {
        return Sandbox.Storybook;
    }
    return Sandbox.None;
};
